import { TableBulkActionView as AntdTableBulkActionView } from "@empglabs/backoffice-ui-kit"

const TableBulkActionView = props => {
  return <AntdTableBulkActionView {...props} />
}

export default TableBulkActionView
